import { render, staticRenderFns } from "./StudyVideo.vue?vue&type=template&id=35e6efcc&scoped=true"
import script from "./StudyVideo.vue?vue&type=script&lang=js"
export * from "./StudyVideo.vue?vue&type=script&lang=js"
import style0 from "./StudyVideo.vue?vue&type=style&index=0&id=35e6efcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6efcc",
  null
  
)

export default component.exports